import {RutsolveToken} from "@/storage/rutsolve_token"

export class Email {
    public static async invoice(orderID: string): Promise<void> {
        const endpoint = process.env.VUE_APP_RUTSOLVE_REST_EMAILS
        const path = `${endpoint}/invoice/${orderID}`
        try {
            await fetch(path, {
                method: "GET",
                headers: {
                    "Authorization": RutsolveToken.read()
                }
            })
        } catch(error) {
            console.error(error)
        }
    }

    public static async offer(orderID: string): Promise<void> {
        const endpoint = process.env.VUE_APP_RUTSOLVE_REST_EMAILS
        const path = `${endpoint}/offer/${orderID}`
        try {
            await fetch(path, {
                method: "GET",
                headers: {
                    "Authorization": RutsolveToken.read()
                }
            })
        } catch(error) {
            console.error(error)
        }
    }
}
